import Alpine from 'alpinejs'
import { convertObjectNumbersToString } from '../helpers/convertObjectNumbersToString'
import { pushDataLayer } from '../helpers/pushDataLayer'
import { Endpoints } from '../site'
import countries from '../countryCodes.json'

// Initial data, used to reset the form.
const initialFormData = () => ({
  lease_id: '',
  first_name: '',
  last_name: '',
  phone_country_code: '+45',
  phone: '',
  email: '',
  company: '',
  company_cvr: '',
  body: '',
  accept_term: false,
  recaptcha_token: '',
})

Alpine.data('bookingForm', (unikLeaseId: string) => ({
  formData: initialFormData(),
  submitted: false,
  errors: null,
  errorMessage: null,
  leaseId: unikLeaseId,
  countries: countries,

  submit() {
    const thisData = this

    if (thisData.formData.lease_id === '') {
      thisData.formData.lease_id = thisData.leaseId
    }

    // google reCaptcha script to get token
    window.grecaptcha.ready(function () {
      window.grecaptcha
        .execute(`${import.meta.env.MIX_RECAPTCHA_SITE_KEY as string}`, { action: 'contact_form' })
        .then(function (token) {
          // token to reCaptcha_token in formData.
          thisData.formData.recaptcha_token = token

          fetch(`${import.meta.env.MIX_API_BASE as string}${Endpoints.bookingForm}`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify(convertObjectNumbersToString(thisData.formData)),
          }).then((response) => {
            if (response.ok) {
              pushDataLayer({
                event: 'book_viewing_form',
                mail: thisData.formData.email, //value changes dynamically
                phone: `${thisData.formData.phone_country_code} ${thisData.formData.phone}`, //value changes dynamically
              })
              thisData.submitted = true
              thisData.errors = null
              thisData.errorMessage = null
              thisData.formData = initialFormData()

              window.dispatchEvent(
                new CustomEvent('notice', {
                  detail: {
                    type: 'success',
                    text: 'Tak for din interesse. Vi sidder klar ved tasterne på hverdage mellem 8 og 17 – og vender retur med et tidspunkt for din fremvisning hurtigst muligt.',
                  },
                })
              )
            }
            if (response.status === 422) {
              thisData.submitted = false
              response.json().then((data) => {
                thisData.errors = data.errors
                thisData.errorMessage = data.message
              })
            } else {
              thisData.submitted = false
              response.json().then((data) => {
                thisData.errors = data.errors
                thisData.errorMessage = data.message
                window.dispatchEvent(
                  new CustomEvent('notice', { detail: { type: 'error', text: data.message } })
                )
              })
            }
          })
        })
    })
  },

  init() {
    this.formData.lease_id = unikLeaseId
  },
}))
